import { ReactNode } from 'react';

export interface ShowcaseProps {
  eyebrow: string;
  title: string;
  tagline: string;
  desc: string;
  bullets: string[];
  /** 비주얼 — 이미지 경로 또는 임의 노드(rows 비주얼 등) */
  image?: string;
  imageAlt?: string;
  visual?: ReactNode;
  /** true 면 비주얼이 좌측, 텍스트가 우측 */
  reverse?: boolean;
}

/**
 * 제품 쇼케이스 — 텍스트/비주얼 2열 교차 레이아웃.
 * 비주얼은 글래스 프레임 이미지 또는 커스텀 노드(rows)를 받는다.
 */
export default function ProductShowcase({
  eyebrow,
  title,
  tagline,
  desc,
  bullets,
  image,
  imageAlt,
  visual,
  reverse,
}: ShowcaseProps) {
  return (
    <section className={`pd-section pd-show${reverse ? ' pd-show--reverse' : ''}`}>
      <div className="pd-container">
        <div className="pd-show__inner">
          <div className="pd-show__text">
            <div className="pd-eyebrow pd-show__eyebrow">{eyebrow}</div>
            <h2 className="pd-h2 pd-show__title">{title}</h2>
            <p className="pd-show__tagline">{tagline}</p>
            <p className="pd-show__desc">{desc}</p>
            <ul className="pd-show__bullets">
              {bullets.map((b) => (
                <li className="pd-show__bullet" key={b}>
                  {b}
                </li>
              ))}
            </ul>
          </div>

          <div className="pd-show__visual">
            {visual ? (
              visual
            ) : (
              <div className="pd-show__frame">
                <img src={image} alt={imageAlt || title} />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
